import React from 'react';
import ParticiplesGame, { PARTICIPLES_GAME_CONFIGS } from './ParticiplesGame';

function ParticiplesGameIII() {
  return <ParticiplesGame gameConfig={PARTICIPLES_GAME_CONFIGS.binyan3} />;
}

export default ParticiplesGameIII;
